import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'trpc-react-native-ui';
import { formatValue } from '../../../lib/usage-formatters';

const MaxUsageChartLabel = props => {
  const color = props.color || 'black';
  const value = isNaN(props.value) ? '' : props.value;

  return <Text style={[props.style, { color }]}>{formatValue(value, props.unitType)}</Text>;
};

MaxUsageChartLabel.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unitType: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

export default MaxUsageChartLabel;
